// @ts-nocheck
import * as types from 'appRedux/actions/file_manager';

const initialState = {
  loader: false,
  form: {
    showModal: false,
    type: null,
    name: '',
    tag_list: [],
    attachment: null,
    mode: 'add',
    selectedAssetId: null,
    showTags: false,
    relatedTags: [],
  },
  searchText: '',
  confirmationModal: {
    show: false,
    selectedAssetId: null,
    type: null,
  },
  files: [],
  folders: [],
  breadcrumb: [],
};

function fileManagerReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_ASSETS_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_ASSETS_SUCCESS:
      return getAssetsSuccess(state, action);

    case types.GET_ASSET_BY_ID_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_ASSET_BY_ID_SUCCESS:
      return getAssetsById(state, action);

    case types.ADD_ASSETS_SUCCESS:
      return addAssetsSuccess(state, action);

    case types.EDIT_ASSET:
      return editAsset(state, action);

    case types.UPDATE_ASSET_SUCCESS:
      return updateAsset(state, action);

    case types.DELETE_ASSET_SUCCESS:
      return deleteAssetSuccess(state, action);

    case types.GET_TAGS_SUCCESS:
      return {
        ...state,
        form: {
          ...state.form,
          relatedTags: action.payload,
        },
      };

    case types.OPEN_TAG_MODAL:
      const {
        payload: { asset },
      } = action;

      return {
        ...state,
        form: {
          ...state.form,
          showModal: true,
          showTag: true,
          mode: 'edit',
          selectedAssetId: asset.id,
          name: asset.name,
          tag_list: asset.tag_list,
          type: asset.is_dir ? 'folder' : 'file',
        },
      };

    case types.OPEN_FORM_MODAL:
      return {
        ...state,
        form: {
          ...state.form,
          showModal: true,
          type: action.payload.type,
        },
      };

    case types.CLOSE_FORM_MODAL:
      return {
        ...state,
        form: {
          showModal: false,
          type: null,
          name: '',
          tag_list: [],
          attachment: null,
          mode: 'add',
          selectedAssetId: null,
          showTags: false,
          relatedTags: [],
        },
      };

    case types.UPDATE_FORM_FIELD:
      const {
        payload: { name, value },
      } = action;
      return {
        ...state,
        form: {
          ...state.form,
          [name]: value,
        },
      };

    case types.UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload.text,
      };

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        confirmationModal: {
          show: true,
          selectedAssetId: action.payload.asset.id,
          type: action.payload.asset.is_dir ? 'folder' : 'file',
        },
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        confirmationModal: {
          show: false,
          selectedAssetId: null,
          type: null,
        },
      };

    default: {
      return state;
    }
  }
}

const getAssetsSuccess = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    loader: false,
    files:
      Object.keys(payload[0]).length > 0 && payload[0].childrens
        ? payload[0].childrens.filter((datum) => !datum.is_dir)
        : [],
    folders:
      Object.keys(payload[0]).length > 0 && payload[0].childrens
        ? payload[0].childrens.filter((datum) => datum.is_dir)
        : [],
    breadcrumb:
      Object.keys(payload[0]).length > 0 && payload[0].breadcrumb
        ? payload[0].breadcrumb
        : [],
  };
};

const getAssetsById = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    loader: false,
    files: payload.childrens
      ? payload.childrens.filter((datum) => !datum.is_dir)
      : [],

    folders: payload.childrens
      ? payload.childrens.filter((datum) => datum.is_dir)
      : [],

    breadcrumb: payload.breadcrumb ? payload.breadcrumb : [],
  };
};

const addAssetsSuccess = (state, action) => {
  const { payload } = action;
  return payload.is_dir
    ? {
        ...state,
        folders: [...state.folders, payload],
      }
    : { ...state, files: [...state.files, payload] };
};

const editAsset = (state, action) => {
  const {
    payload: { asset },
  } = action;
  return {
    ...state,
    form: {
      ...state.form,
      showModal: true,
      mode: 'edit',
      selectedAssetId: asset.id,
      name: asset.name,
      tag_list: asset.tag_list,
      type: asset.is_dir ? 'folder' : 'file',
    },
  };
};

const updateAsset = (state, action) => {
  if (action.payload.is_dir) {
    return {
      ...state,
      folders: state.folders.map((folder) =>
        folder.id === action.payload.id ? action.payload : folder,
      ),
    };
  }
  return {
    ...state,
    files: state.files.map((file) =>
      file.id === action.payload.id ? action.payload : file,
    ),
  };
};

const deleteAssetSuccess = (state, action) => {
  const {
    payload: { type },
  } = action;

  if (type === 'file') {
    return {
      ...state,
      files: state.files.filter((file) => file.id !== action.payload.id),
    };
  }

  return {
    ...state,
    folders: state.folders.filter((folder) => folder.id !== action.payload.id),
  };
};

export default fileManagerReducer;
